<template>
    <div class="main">
        <div class="cbanner">
            <img src="../../../assets/images/banner_partner.jpg" />
            <div class="btext">
                <h3>合作共赢</h3>
                <p>我们与合作伙伴携起手来，精诚合作，共享未来！</p>
            </div>
        </div><!-- channel banner END-->
        <div class="main_inner">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <span class="btitle">当前位置：</span>
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>合作伙伴</el-breadcrumb-item>
            </el-breadcrumb>
            <el-row>
                <el-col :span="5" class="leftside">
                    <el-menu
                            default-active="1"
                            class="el-menu-vertical-demo"
                    >
                        <router-link :to="{ path: '/cooperativePartner' }">
                            <el-menu-item index="1"><span slot="title" >合作伙伴</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/lawStatement' }">
                            <el-menu-item index="2"><span slot="title">法律申明</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/recruitment' }">
                            <el-menu-item index="3"><span slot="title">招贤纳士</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/contactUs' }">
                            <el-menu-item index="4"><span slot="title">联系我们</span></el-menu-item>
                        </router-link>
                      <router-link :to="{ path: '/centerAnswer' }">
                        <el-menu-item index="5"><span slot="title">平台问答</span></el-menu-item>
                      </router-link>
                    </el-menu>
                </el-col>
                <el-col :span="19">
                    <div class="con_right">
                        <div class="con">
                            <div class="news_detail">
                                <div class="content_news" v-html="this.content">

                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import  {reqCooperativePartnerList} from "../../../api/contentManagement-api"
    export default {
        data(){
            return{
                content:'',
            }
        },
        methods:{
            getCooperativePartner(){
                reqCooperativePartnerList().then((res)=>{
                    if(res.data.code===1){
                        this.content=res.data.data[0].content;
                    }else{
                        this.content='<p>抱歉，暂无数据</p>'
                    }
                })
            }

        },
        mounted(){
            this.$store.dispatch('showHF');
            this.getCooperativePartner();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/contentManagement/otherPage/cooperativePartner.vue